import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import { QRCodeCanvas } from 'qrcode.react';

export default function FloatingAppDownload() {
  const [isVisible, setIsVisible] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);
  const { configInfo } = useSelector((state: RootState) => state.settings);
  const iosDownloadUrl = configInfo?.ios_down||'https://readdy.ai/api/search-image?query=QR%20code%20for%20mobile%20app%20download%2C%20white%20background%2C%20clean%20design%2C%20square%20format%2C%20black%20and%20white%20pattern&width=128&height=128&seq=qr-code-app&orientation=squarish';
  const androidDownloadUrl = configInfo?.ad_down||'https://readdy.ai/api/search-image?query=QR%20code%20for%20mobile%20app%20download%2C%20white%20background%2C%20clean%20design%2C%20square%20format%2C%20black%20and%20white%20pattern&width=128&height=128&seq=qr-code-app&orientation=squarish';

  useEffect(() => {
    if (iosDownloadUrl || androidDownloadUrl) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [iosDownloadUrl, androidDownloadUrl]);

  const handleClose = () => {
    setIsVisible(false);
  };

  // if (!isVisible || (!iosDownloadUrl && !androidDownloadUrl)) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col items-end">
      {/* 二维码弹出框 */}
      {showQRCode && (
        <div className="mb-3 bg-white rounded-lg shadow-xl border p-4 w-72 animate-fadeIn">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-bold text-gray-900 text-sm">扫码下载APP</h3>
            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 cursor-pointer"
            >
              <i className="ri-close-line text-sm"></i>
            </button>
          </div>
          
          <div className="flex justify-around text-center">
            {iosDownloadUrl && (
              <div className="flex flex-col items-center">
                <div className="w-28 h-28 mx-auto mb-2 bg-gray-100 rounded-lg flex items-center justify-center border p-1">
                  <QRCodeCanvas
                    value={iosDownloadUrl}
                    size={100}
                    level={"H"}
                    imageSettings={{
                      src: "https://best-image-1325343149.cos.ap-guangzhou.myqcloud.com/logo.png",
                      x: undefined,
                      y: undefined,
                      height: 20,
                      width: 20,
                      excavate: true,
                    }}
                  />
                </div>
                <div className="flex items-center text-xs text-gray-500">
                  <i className="ri-apple-line mr-1"></i>
                  <span>iOS</span>
                </div>
              </div>
            )}
            {androidDownloadUrl && (
              <div className="flex flex-col items-center">
                <div className="w-28 h-28 mx-auto mb-2 bg-gray-100 rounded-lg flex items-center justify-center border p-1">
                  <QRCodeCanvas
                    value={androidDownloadUrl}
                    size={100}
                    level={"H"}
                    imageSettings={{
                      src: "https://best-image-1325343149.cos.ap-guangzhou.myqcloud.com/logo.png",
                      x: undefined,
                      y: undefined,
                      height: 20,
                      width: 20,
                      excavate: true,
                    }}
                  />
                </div>
                <div className="flex items-center text-xs text-gray-500">
                  <i className="ri-android-line mr-1"></i>
                  <span>Android</span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 悬浮按钮容器 */}
      <div 
        className="relative w-14 h-14 md:w-16 md:h-16"
        onMouseEnter={() => setShowQRCode(true)}
        onMouseLeave={() => setShowQRCode(false)}
      >
        {/* 脉冲动画背景 - 放在按钮后面 */}
        <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-20 pointer-events-none"></div>
        
        {/* 主按钮 */}
        <button className="relative w-full h-full bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center cursor-pointer group z-10">
          <i className="ri-smartphone-line text-xl md:text-2xl transition-transform duration-300 group-hover:rotate-12"></i>
        </button>
      </div>
    </div>
  );
}